import { ItemExpireContext as MessageExpireContext, MessageMetaRoot } from '@halo/ui-chat-react';
import type { Session } from '@halo/chat-sdk-react';
import { Center } from '@chakra-ui/react';
import {
  MsgAvatar,
  MsgBody,
  MsgBubble,
  MsgExpireAnimate,
  MsgHeader,
  MsgItem,
  MsgReadStatus,
} from '../../msg-parts';
import type { MsgEncryptFailedContentProps } from './msg-encrypt-failed-content';
import { MsgEncryptFailedContent } from './msg-encrypt-failed-content';

export interface MsgEncryptFailedProps extends MsgEncryptFailedContentProps {
  session: Session;
}

export const MsgEncryptFailed = memo(function MsgEncryptFailed({
  session,
  message,
}: MsgEncryptFailedProps) {
  return (
    <MsgItem message={message}>
      <MessageExpireContext message={message}>
        <MsgAvatar message={message} session={session} />
        <MsgBody message={message}>
          <MsgHeader message={message} session={session} />
          <MsgExpireAnimate session={session} message={message}>
            <MsgBubble message={message}>
              <MsgEncryptFailedContent message={message}></MsgEncryptFailedContent>
              <MessageMetaRoot>
                <Center marginLeft="auto" gap="1.5">
                  <MsgReadStatus message={message} session={session} />
                </Center>
              </MessageMetaRoot>
            </MsgBubble>
          </MsgExpireAnimate>
        </MsgBody>
      </MessageExpireContext>
    </MsgItem>
  );
});
